/* eslint-disable @typescript-eslint/no-unused-vars */
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AppDriverConfig } from '../../const/AppDriverConfig';
import { AppClientConfig } from '../../const/AppClientConfig';

@Injectable()
export class VersionControlDataService {
  private _activeSection!: string;
  constructor(private _router: Router) {
    this.setActiveSection(this._router.url);
  }

  private setActiveSection(url: string) {
    const splitedUrl = url.split('/');
    this._activeSection = splitedUrl[splitedUrl.length - 2];
  }

  getActiveSection() {
    return this._activeSection;
  }

  getAppConfig() {
    switch (this._activeSection) {
      case 'driver': {
        return AppDriverConfig;
      }
      case 'client': {
        return AppClientConfig;
      }
      default:
        throw new Error(`'${this._activeSection}' no es una ruta definida`);
    }
  }
}
